export const BareChartOptions = {
	chart: {
		height: '100px',
		type: 'line',
		zoom: {
			enabled: false
		},
		toolbar: {
			show: false
		},
	},
	dataLabels: {
		enabled: false
	},
	stroke: {
		curve: 'smooth',
		lineCap: 'butt',
		width: 3,
		dashArray: 0,  
	},
	axisTicks: {
		show: false
	},
	axisBorder: {
		show: false
	},
	yaxis: {
		labels: {
			maxWidth: 0,
			show: false
		},
	},
	xaxis: {
		labels: {
			maxHeight: 0,
			show: false
		},
	},
	grid: {
		show: false,
	},
	tooltip: {
		enabled: false
	},
}